import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ThreeDots from "components/common/Loader/ThreeDots";
import { default as React, ReactNode } from "react";
import theme from "themes/simple-theme";

export interface IProps {
  completed: boolean;
  primary: boolean;
  completedText: string;
  loading: boolean;
  children: ReactNode;
}

const ButtonContent = ({
  completed,
  completedText,
  loading,
  primary,
  children
}) => {
  if (loading) {
    return (
      <ThreeDots
        width={38}
        height={14}
        color={primary ? theme.color.white : theme.color.primary}
      />
    );
  }
  if (completed) {
    return (
      <>
        {completedText ? completedText : "Updated"}{" "}
        <FontAwesomeIcon icon="check" />
      </>
    );
  } else {
    return children;
  }
};

export default ButtonContent;



// WEBPACK FOOTER //
// ./src/components/common/Button/ButtonContent.tsx